import classNames from 'classnames';
import * as React from 'react';
import type { LinkProps } from '~/Partials/Link/Link';
import { Link } from '~/Partials/Link/Link';
import { LinkType } from '~/Partials/Link/LinkType.csharp';
import type { IconName } from '~/Partials/SvgIcon/SvgIcon';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './PortfolioItemInfo.module.css';

export interface PortfolioItemInfoProps {
    linkRef: React.RefObject<HTMLAnchorElement>;
    title?: string;
    link?: LinkProps;
    visibleOnInteractOnly?: boolean;
    caption?: string;
    iconName?: IconName;
    orientation?: 'vertical' | 'horizontal';
}

export const PortfolioItemInfo: React.FC<PortfolioItemInfoProps> = props => {
    const { title, linkRef, link, caption, iconName, visibleOnInteractOnly = false, orientation = 'vertical' } = props;

    const getTitleElement = () => {
        const titleText = title || (link && 'label' in link && link.label) || '';

        if (titleText && link) {
            return (
                <Link ref={linkRef} {...link} showIsExternal={false} type={LinkType.Clear} className={styles.Link}>
                    <div className={styles.Title}>{titleText}</div>
                </Link>
            );
        }

        if (titleText) {
            return <div className={styles.Title}>{titleText}</div>;
        }

        return null;
    };

    const titleElement = getTitleElement();
    const captionElement = caption ? <div className={styles.Caption}>{caption}</div> : null;
    const iconElement = iconName ? <SvgIcon iconName={iconName} className={styles.Icon} /> : null;

    const topClassName = classNames(
        styles.PortfolioItemInfo,
        styles[`Orientation--${orientation}`],
        visibleOnInteractOnly && styles['Variant--visibleOnInteractOnly']
    );

    if (titleElement && captionElement && iconElement) {
        return (
            <div className={topClassName}>
                {titleElement}
                <div className={styles.IconWrapper}>
                    {captionElement}
                    {iconElement}
                </div>
            </div>
        );
    }

    if (!iconElement) {
        return (
            <div className={topClassName}>
                {titleElement}
                {captionElement}
            </div>
        );
    }

    return (
        <div className={topClassName}>
            <div className={styles.IconWrapper}>
                {titleElement || captionElement}
                {iconElement}
            </div>
        </div>
    );
};
